import { ReactElement } from 'react';

// Components
import { Welcome } from './Welcome';
import { Search } from './Search';
import { Featured } from './Featured';

// Globals.
import background from 'globals/images/cmeHero.png';

// Styles
import styles from './index.module.scss';
import { Box } from '@mui/material';

export const Hero = (): ReactElement => {
  return (
    <Box className={styles.hero} sx={{ backgroundImage: `url(${background})` }}>
      <Welcome />
      <Search />
      <Featured />
    </Box>
  );
};
